<template>
  <div class="card-container" @click="handleClick">
    <div v-if="obj.imageURL" class="img-container">
      <img :src="obj.imageURL" alt="shotracker" />
    </div>

    <div>
      <div class="test">
        <p class="card-header">
          {{ obj.header }}
        </p>
      </div>

      <p class="card-subheader">{{ obj.subheader }}</p>
    </div>
  </div>
</template>

<script>
import { generateLink } from '../utils/helpers'

export default {
  name: 'Card',

  props: {
    obj: Object,
  },

  methods: {
    handleClick() {
      window.location.href = generateLink(this.obj.id)
    },
  },
}
</script>

<style scoped>
.card-container {
  padding: 30px;
  background-color: white;
  box-shadow: 0 0 10px #ccc;
  height: 100%;
  cursor: pointer;
}

.img-container {
  margin: 0 auto;
  text-align: center;
}

.card-container img {
  max-width: 100%;
  height: auto;
  margin: 0 auto;
  object-fit: contain;
  box-shadow: 0 0 10px #ccc;
}

.card-header {
  font-family: 'AvenirBlack';
  font-weight: 900;
  color: #565656;
  text-transform: uppercase;
  margin-top: 10px;
  margin-bottom: 5px;
  font-size: 22px;
}

.card-subheader {
  font-family: 'AvenirRoman';
  font-size: 18px;
  font-weight: 200;
  color: grey;
}
</style>
